import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Close } from '@mui/icons-material';

const TransferenciaFormModal = ({ open, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    cantidades: { cajas: 0, carpetas: 0, tomos: 0, otros: 0 },
    disposicionFinal: '',
    observaciones: '',
    bodega: '',
    recolector: { nombre: '' },
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCantidadChange = (field, value) => {
    setFormData({
      ...formData,
      cantidades: { ...formData.cantidades, [field]: parseInt(value) || 0 },
    });
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit(formData);
      setFormData({
        cantidades: { cajas: 0, carpetas: 0, tomos: 0, otros: 0 },
        disposicionFinal: '',
        observaciones: '',
        bodega: '',
        recolector: { nombre: '' },
      });
      onClose();
    } catch {
      // error handled by parent
    } finally {
      setSubmitting(false);
    }
  };

  const totalItems = Object.values(formData.cantidades).reduce((a, b) => a + b, 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600}>Nueva Transferencia Documental</Typography>
          <IconButton onClick={onClose} size="small"><Close /></IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
              Cantidades (GDI-FR-01)
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <TextField
              fullWidth
              type="number"
              label="Cajas"
              value={formData.cantidades.cajas}
              onChange={(e) => handleCantidadChange('cajas', e.target.value)}
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <TextField
              fullWidth
              type="number"
              label="Carpetas"
              value={formData.cantidades.carpetas}
              onChange={(e) => handleCantidadChange('carpetas', e.target.value)}
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <TextField
              fullWidth
              type="number"
              label="Tomos"
              value={formData.cantidades.tomos}
              onChange={(e) => handleCantidadChange('tomos', e.target.value)}
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <TextField
              fullWidth
              type="number"
              label="Otros"
              value={formData.cantidades.otros}
              onChange={(e) => handleCantidadChange('otros', e.target.value)}
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Disposicion Final"
              name="disposicionFinal"
              value={formData.disposicionFinal}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Bodega Destino"
              name="bodega"
              value={formData.bodega}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Nombre del Recolector"
              value={formData.recolector.nombre}
              onChange={(e) =>
                setFormData({ ...formData, recolector: { ...formData.recolector, nombre: e.target.value } })
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Observaciones"
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={totalItems === 0 || submitting}>
          Crear Transferencia
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferenciaFormModal;
